import React from "react";
import { ILuckyWheelSummaryModel } from "../../models/eventModel";
import EventServices from "../../services/event";
import { Form, Modal, Select } from "antd";

const Summary = () => {
  const [event, setEvent] = React.useState<any>();
  const [stores, setStores] = React.useState<any[]>([]);
  const [summary, setSummary] = React.useState<ILuckyWheelSummaryModel[]>([]);
  const [gifts, setGifts] = React.useState<any[]>([]);
  const [visible, setVisible] = React.useState(true);

  const [form] = Form.useForm();

  const sortedSummary = summary.sort((a, b) => {
    return b.order - a.order;
  });

  React.useEffect(() => {
    getEventLuckyWheel();
  }, []);

  React.useEffect(() => {
    if (event) {
      getEventStores();
    }
  }, [event]);

  // React.useEffect(() => {
  //   if (
  //     query &&
  //     query.event_id &&
  //     query.store_code &&
  //     typeof query.event_id === "string" &&
  //     typeof query.store_code === "string"
  //   ) {
  //     getEventLuckyWheelSummary(query.event_id, query.store_code);
  //     getEventLuckyWheelGifts(query.event_id, query.store_code);
  //   }

  //   // const intervalId = setInterval(() => {
  //   //   if (
  //   //     query &&
  //   //     query.event_id &&
  //   //     query.store_code &&
  //   //     typeof query.event_id === "string" &&
  //   //     typeof query.store_code === "string"
  //   //   ) {
  //   //     getEventLuckyWheelSummary(query.event_id, query.store_code);
  //   //   }
  //   // }, 10000);

  //   // return () => {
  //   //   clearInterval(intervalId);
  //   // };
  // }, []);

  const getEventLuckyWheel = async () => {
    const rs = await EventServices.getEventLuckyWheel();

    if (!rs) {
      return;
    }

    setEvent(rs);
  };

  const getEventStores = async () => {
    const rs = await EventServices.getEventStores();

    if (!rs || !rs.store_applies) {
      return;
    }

    setStores(rs.store_applies);
  };

  const getEventLuckyWheelSummary = async (
    eventId: string,
    storeCode: string
  ) => {
    const rs = await EventServices.getEventLuckyWheelSummary(
      eventId,
      storeCode
    );

    if (!rs) {
      return;
    }

    setSummary(rs.slice(0, 10));
  };

  const getEventLuckyWheelGifts = async (
    eventId: string,
    storeCode: string
  ) => {
    const rs = await EventServices.getEventGifts(eventId, storeCode);

    if (!rs) {
      return;
    }

    setGifts(rs);
  };

  // const markPhoneNumber = (phoneNumber: string) => {
  //   return phoneNumber.replace(/(\d{0,})(\d{3})/, "*******$2");
  // };

  const handleSubmit = (values: any) => {
    getEventLuckyWheelSummary(values.event_id, values.store_code);
    getEventLuckyWheelGifts(values.event_id, values.store_code);
    setVisible(false);
  };

  const showSTT = (stt: number) => {
    if (stt < 10) {
      return `0${stt}`;
    }
    return stt;
  };

  const showRows = () =>
    new Array(10).fill(0).map((_, index) => {
      const img =
        index % 2 === 0
          ? "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-row-2.svg"
          : "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-row-1.svg";

      const top = 91 + 47 * index;

      return (
        <div
          className="customer-reward"
          style={{ top: top, backgroundImage: `url("${img}")` }}></div>
      );
    });

  const showItems = () => {
    return sortedSummary.map((item, index) => {
      const top = 88 + 47 * index;

      return (
        <div className="customer-reward-info" style={{ top: top }}>
          <div>{showSTT(sortedSummary.length - index)}</div>
          <div>{item.customer_name}</div>
          <div>{item.kde_order_id}</div>
          <div>{item.gift_name}</div>
        </div>
      );
    });
  };

  const showGiftItems = () =>
    gifts.map((item) => (
      <div className="lucky-wheel-gifts-item">
        <div className="lwgi-left">
          còn <b>{item.quantity - item.quantity_reward}</b> giải
        </div>
        <div className="lwgi-right">{item.display_name}</div>
      </div>
    ));

  const showStoreOptions = () => {
    return stores.map((store) => (
      <Select.Option key={store.code} value={store.code}>
        {store.name}
      </Select.Option>
    ));
  };

  if (!event) {
    return null;
  }

  if (!summary.length) {
    return (
      <div className="screen-lucky-wheel-master">
        <Modal
          visible={visible}
          cancelText="Đóng"
          title="Sự kiện & Khách hàng"
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          onOk={() => form.submit()}>
          <Form form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Sự kiện"
              name="event_id"
              rules={[{ required: true, message: "Vui lòng chọn sự kiện" }]}
              labelCol={{ span: 5 }}
              labelAlign="right"
              initialValue={event._id}>
              <Select>
                <Select.Option key={event?._id} value={event?._id}>
                  {event?.display_name}
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Cửa hàng"
              name="store_code"
              rules={[{ required: true, message: "Vui lòng chọn cửa hàng" }]}
              labelCol={{ span: 5 }}
              labelAlign="right">
              <Select allowClear placeholder="Vui lòng chọn cửa hàng">
                {showStoreOptions()}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  return (
    <div className="screen-lucky-wheel-master lucky-wheel-summary">
      <div className="lucky-wheel-items">
        <div className="lucky-wheel-gifts">
          <img
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-product-list.svg"
            alt=""
          />
          <div className="lucky-wheel-gifts-title">Giải thưởng</div>
          <div className="lucky-wheel-gifts-listing">{showGiftItems()}</div>
          <div className="lucky-wheel-gift-dot">
            <img
              src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/ic-ball.svg"
              alt=""
            />
          </div>
        </div>
        <div className="customer-rewards">
          <img
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-summary.svg"
            alt=""
          />
          <div className="customer-rewards-header">
            <div>STT</div>
            <div>Khách hàng</div>
            <div>Mã đơn hàng</div>
            <div>Trúng thưởng</div>
          </div>
          {showRows()}
          {showItems()}
        </div>
        <button className="lucky-wheel-button">
          Danh sách khách hàng trúng thưởng
        </button>
        <button className="lucky-wheel-button">Thể lệ chương trình</button>
        {/* <div>
          <img
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/btn-normal.svg"
            alt=""
          />
        </div>
        <div>
          <img
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/btn-qr.svg"
            alt=""
          />
        </div> */}
      </div>
    </div>
  );
};

export default Summary;
